import { IInset } from './IInset';

export type TInsetCallback = (inset: IInset) => void;
